import Request from '../request/Request';
import BackendModel from '../model/BackendModel';
import Mapper from '../model/Mapper';
import { isType } from '../js';
import setup from '../setup/setup';


/**
 * Backend to handle basic requests
 */

class Backend {
	
	public apiKey:string;
	public mapper:Mapper;
	
	constructor() {

		this.mapper = new Mapper();

		// inject function to set reference on backend
		var orgFunc = this.mapper.model;
		this.mapper.model = ( json:any ) => {
			var result = orgFunc.call( this.mapper, json );

			if( result instanceof BackendModel ) {
				result.backend = this;
			}

			return result;
		}
	}
	
	public update( model:BackendModel ) {
		var modelJson = this.serialize( model );
		return setup.route( this.apiKey + '.update', model.object() ).send( modelJson ).then( this.mapper.model.bind( this ) );
	}
	
	public create( model:BackendModel ) {
		var modelJson = this.serialize( model );
		return setup.route( this.apiKey + '.create', model.object() ).send( modelJson ).then( this.mapper.model.bind( this ) );
	}
	
	public delete( model:BackendModel ) {
		var modelJson = this.serialize( model );
		return setup.route( this.apiKey + '.delete', model.object() ).send( modelJson );
	}
	
	
	/**
	 * Properly serializes the object to sent to the backend
	 */
	public serialize( model:BackendModel ):string {
		var json = this.mapper.json( model );

		// reduce relations on attributes
		for( var attr in json ) {
			if( json.hasOwnProperty( attr ) ) json[ attr ] = this.reduceRelations( json[ attr ] );
		}

		return JSON.stringify( json );
	}
	

	/**
	 * Reduces the relations to simple id/modelName objects
	 */
	public reduceRelations( data:any ) {
		
		// check on object relations
		if( isType( data, "Object" ) && data.modelName && data.id ) {
			return { id:data.id, modelName:data.modelName };
		}

		// check arrays
		if( isType( data, "Array" ) ) {
			return data.map( ( child ) => {
				return this.reduceRelations( child );
			});
		}
		
		// any other simply return
		return data;
	}
}

export default Backend;